var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ArcBaseService } from './arc-base.service';
import { LoadingService } from './loading.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { loadModules } from 'esri-loader';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
var Review = /** @class */ (function () {
    function Review() {
    }
    return Review;
}());
export { Review };
var ReviewService = /** @class */ (function (_super) {
    __extends(ReviewService, _super);
    function ReviewService(snackBar, loadingService) {
        return _super.call(this, '6', snackBar, loadingService) || this;
    }
    ReviewService.prototype.create_new_review = function () {
        var vm = this;
        var config = new ConfigService();
        return new Observable(function (obs) {
            vm.layerIsLoaded.subscribe(function () {
                loadModules(['esri/graphic', 'esri/geometry/Polygon', 'esri/SpatialReference'], config.jsapi_config).then(function (_a) {
                    var Graphic = _a[0], Polygon = _a[1], SpatialReference = _a[2];
                    var review = new Graphic(vm.layer.templates[0].prototype.toJson());
                    review.attributes.GlobalID = 'new';
                    obs.next(review);
                    obs.complete();
                });
            });
        });
    };
    return ReviewService;
}(ArcBaseService));
export { ReviewService };
